const initialState = {
  previousPath: null,
  routeLoading: false
};

export default initialState;